
















import { Component, Vue } from 'vue-property-decorator';
import { BContainer } from 'bootstrap-vue';

@Component({
    components: {
        'b-container': BContainer
    }
})
export default class PageFooter extends Vue {

}
